var global = require('../internals/global');

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/try-to-string.js
// module id = 109
// module chunks = 49